import styled from 'styled-components';

export const QuestionContainer = styled.div`
  border: 1px solid #333333;
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
`;
